import React from "react";

function MapMarkerLargeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="32"
      viewBox="0 0 24 32"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <circle cx="11.5" cy="11.5" r="7.5" fill="#FFF"></circle>
          <g fill="currentColor" fillRule="nonzero">
            <path d="M10.767 31.354C1.686 18.19 0 16.838 0 12 0 5.373 5.373 0 12 0s12 5.373 12 12c0 4.838-1.686 6.19-10.767 19.354a1.5 1.5 0 01-2.466 0zM12 17a5 5 0 100-10 5 5 0 000 10z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MapMarkerLargeIcon;
